import { render, staticRenderFns } from "./NavigateWeb.vue?vue&type=template&id=89feccc6&scoped=true&"
import script from "./NavigateWeb.vue?vue&type=script&lang=js&"
export * from "./NavigateWeb.vue?vue&type=script&lang=js&"
import style0 from "./NavigateWeb.vue?vue&type=style&index=0&id=89feccc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89feccc6",
  null
  
)

export default component.exports